import React, { Component } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import {
    buildCategoryNameKey,
    buildNestedSubCategoryNameKey,
    buildSubCategoryNameKey
} from '../../../utils/translation/categories';
import {
    MP_CLICKED_BREADCRUMBS_PRO,
    MP_CLICKED_BREADCRUMBS_CATEGORY,
    MP_CLICKED_BREADCRUMBS_SUBCATEGORY,
    MP_CLICKED_BREADCRUMBS_NESTED_SUBCATEGORY
} from '../../../utils/mixPanelEvents';
import {
    getCategoryUrl,
    getSubCategoryUrl,
    getNestedSubCategoryUrl,
    getProUrl
} from '../../../utils/routes';

import './style.scss';

class Breadcrumbs extends Component {

    reportClickEvent(eventName) {
        const { biEvents, general } = this.context;
        const params = _.pick(general, [
            'categoryId', 'subCategoryId', 'nestedSubCategoryId', 'isPro'
        ]);
        biEvents.sendMixPanelEvent({
            eventName,
            params
        });
    }

    render() {
        const { general } = this.context;
        const {
            categoryId,
            subCategoryId,
            nestedSubCategoryId,
            isPro
        } = general;

        if (!(categoryId && subCategoryId)) {
            return null;
        }

        const showSubCategoryAndCategory = categoryId && subCategoryId;
        const showNestedSubCategory = showSubCategoryAndCategory && nestedSubCategoryId;
        const classes = classNames('breadcrumbs', 'text-body-2');

        return (
            <nav className={classes}>
                {isPro &&
                <a href={getProUrl(this.context)}
                    onClick={() => this.reportClickEvent(MP_CLICKED_BREADCRUMBS_PRO)}>
                    <I18n k="gig_page_perseus.general.fiverr_pro"/>
                </a>
                }
                {showSubCategoryAndCategory &&
                <a href={getCategoryUrl(this.context)}
                    onClick={() => this.reportClickEvent(MP_CLICKED_BREADCRUMBS_CATEGORY)}>
                    <I18n k={buildCategoryNameKey(categoryId)}/>
                </a>
                }
                {showSubCategoryAndCategory &&
                <a href={getSubCategoryUrl(this.context)}
                    onClick={() => this.reportClickEvent(MP_CLICKED_BREADCRUMBS_SUBCATEGORY)}>
                    <I18n k={buildSubCategoryNameKey(subCategoryId)}/>
                </a>
                }
                {showNestedSubCategory &&
                <a href={getNestedSubCategoryUrl(this.context)}
                    onClick={() => this.reportClickEvent(MP_CLICKED_BREADCRUMBS_NESTED_SUBCATEGORY)}>
                    <I18n k={buildNestedSubCategoryNameKey(subCategoryId, nestedSubCategoryId)}/>
                </a>
                }
            </nav>
        );
    }
}

Breadcrumbs.contextTypes = {
    general: object,
    pathfinderWrapper: object,
    biEvents: object
};

export default Breadcrumbs;

